<template>
  <div>
    <table>
      <template v-if="attend && attend.workType === 'NON_WORK'">
        <tr>
          <td :class="{
              'non-work-day': true,
              'public-leave': attend && attend.status === 'PUBLIC_LEAVE'
            }">
            <span class="non-work-text">{{ nonWorkLabel }}</span>
          </td>
        </tr>
        <tr v-if="attend.memo">
          <td style="text-align: center;">
            {{ attend.memo }}
          </td>
        </tr>
      </template>
      <template v-else-if="attend">
        <tr v-if="lateAffect && currentPage === 1" style="font-weight: bold;">
          <td class="time">{{ lateAffect.time }}</td>
          <td>지각</td>
        </tr>

        <tr v-for="(attend, index) in attend.attends" :key="index">
          <td class="time">{{ attend ? attend.time : '' }}</td>
          <td >
            {{ attend ? attend.place : '' }}
          </td>
        </tr>

        <tr v-if="earlyLeaveAffect && totalPage === currentPage" style="font-weight: bold;">
          <td class="time">{{ earlyLeaveAffect.time }}</td>
          <td>조퇴</td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    attend: {
      type: Object,
      default: () => ({})
    },
    totalPage: {
      type: Number,
      default: () => 0
    },
    currentPage: {
      type: Number,
      default: () => 0
    }
  },
  computed: {
    nonWorkLabel () {
      // {{ attend.workType }} {{ attend.status }}
      if (this.attend.workType !== 'WORK') {
        switch (this.attend.status) {
          case 'ANNUAL_LEAVE': return '연차'
          case 'SICK_LEAVE': return '병가'
          case 'PUBLIC_LEAVE': return '공가'
          case 'SPECIAL_LEAVE': return '휴가'
          case 'ABSENT': return '결근'
          default: return ''
        }
      } else {
        return ''
      }
    },
    lateAffect () {
      if (this.attend && this.attend.workType === 'TIME_AFFECT') {
        return this.attend.timeAffects.find(t => t.type === 'LATE')
      }
    },
    earlyLeaveAffect () {
      if (this.attend && this.attend.workType === 'TIME_AFFECT') {
        return this.attend.timeAffects.find(t => t.type === 'EARLY_LEAVE')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Report/Attendance/DailyItem.vue